<template>
  <el-dialog
    class="xgtz"
    title="打卡走势"
    :visible.sync="visible"
    width="965px"
    :before-close="close"
  >
    <ul class="header">
      <li :class="{ on: num == 1 }" @click="loadData">饮食</li>
      <li :class="{ on: num == 2 }" @click="loadData">
        运动
      </li>
      <li :class="{ on: num == 3 }" @click="loadData">睡眠</li>
    </ul>
    <ul class="nvetime">
      <li :class="{ on: timenum == 1 }" @click="loadData">近一周</li>
      <li :class="{ on: timenum == 2 }" @click="loadData">近半月</li>
    </ul>
    <div
      id="checkChart"
      :style="{ width: '925px', height: '380px', border: '1px solid #E3E3E3' }"
    ></div>
  </el-dialog>
</template>

<script>


export default {
  name: "punchCard-dialog",
  props: ['visible','user'],
  data() {
    return {
      dates: null,
      highs: null,
      lows:null,
      num:1,
      timenum:1
    };
  },
  mounted() {
    var that=this;
    that.$watch('visible', function() {
      console.log('that.user',that.user);
        if(that.user){
          that.loadData();
        }
    });
  },
  methods: {
    dedupe(array) {
      return Array.from(new Set(array));
    },
    close(){
      var that=this;
      that.$emit("close");
    },
    loadData() {
      var that=this;
      // var params={
      //   userId:that.user.id
      // }
      // that.api.checkCharts(params).then(()=>{
       
        var mock='{\"msg\":\"success\",\"code\":0,\"page\":{\"totalCount\":1,\"pageSize\":10,\"totalPage\":1,\"currPage\":1,\"list\":[{\"id\":11,\"high\":129,\"low\":79,\"userId\":2,\"generateTime\":\"2022-01-13 22:28:52\",\"batchNo\":\"2022-01-12 22:37:30\",\"createTime\":\"2022-01-13 22:28:52\",\"updateTime\":\"2022-01-13 22:28:52\"}]}}';// eslint-disable-line
        mock=JSON.parse(mock);
        var list = mock.page.list;
       
        var njllb = [];
        var dates = [];
        var highs = [];
        var lows = [];
        for (var i = 0; i < list.length; i++) {
          var jl = list[i];
          var njl = {};
          njl.title = "饮食";
          njl.value = jl.high + "/" + jl.low;
          njl.date = new Date(jl.createTime.iphoneDateFormat()).format("MM-dd");
          dates.push(njl.date);
          highs.push(jl.high);
          lows.push(jl.low);
          njllb.push(njl);
        }
        that.dates = dates.reverse();
        that.highs = highs.reverse();
        that.lows = lows.reverse();
        
        that.drawLine();
      // });
    },
    drawLine() {
      var data = [[0,0],[1,0]];
      var data2 = [[0,1],[1,1],[2,1]];
      var data3 = [[],[1,2],[2,2]];
      var dates = ['09-18','09-19','09-20'];
      var ydatas = ['早餐','午餐','晚餐'];
      // var num=this.dates.length;
      // num=num>7?7:num;
      // for (var i = 0; i < num; i++) {
      //   data.push([i, this.highs[i]]);
      //   data2.push([i, this.lows[i]]);
      //   dates.push(this.dates[i]);
      // }
      console.log(data,data2,dates);
      // 绘制图表
      var option={
        color: ["#F0F", "#FFD6A6"],
        backgroundColor: "transparent",
        xAxis: {
          data: dates,
          axisLabel: {
            
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true
          },
          splitLine: {
            show: true
          }
        },
        yAxis: {
          data:ydatas,
          axisLabel: {
            
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true
          },
          splitLine: {
            lineStyle: {
              color: "#F1F1F2",
              type: "solid"
            }
          }
        },
        legend: {
          show: true
        },

        series: [
          {
            type: "scatter",
            name: "早餐",
            data: data
          },
          {
            name: "午餐",
            type: "scatter",
            data: data2
          },
          {
            name: "晚餐",
            type: "scatter",
            data: data3
          }
        ],
        // grid: {
        //   top: "10%",
        //   left: "5%",
        //   right: "5%",
        //   bottom: "0",
        //   containLabel: true
        // },
        animationDelay: function(idx) {
          return idx * 50;
        },
        animationEasing: "elasticOut"
      };
      var checkChart = this.$echarts.init(document.getElementById("checkChart"));
      console.log('checkChart',checkChart);
      console.log('option',option);
      option && checkChart.setOption(option, true);
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.xgtz {
  .header {
    display: flex;
    margin-bottom: 24px;
    li {
      width: 230px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #f1f1f2;
      font-weight: bold;
      border: 1px solid #e3e3e3;
    }
    .on {
      background: #d5e4ff;
      border: 1px solid #185ad6;
      color: #185ad6;
    }
  }
  .nvetime {
    display: flex;
    position: absolute;
    left: 20px;
    top: 143px;
    z-index: 100;
    li {
      width: 72px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-weight: bold;
      border: 1px solid #e3e3e3;
      border-radius: 2px 2px 0px 0px;
    }
    .on {
      border: 1px solid transparent;
      color: #185ad6;
    }
  }
  .el-dialog__body {
    padding:30px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
}
</style>
